module.exports = __webpack_public_path__ + "static/media/robot-green-1-up.f97d996a.svg";